import productionLinks from '@grupa-pracuj/business-variables/dist/production';
import betaLinks from '@grupa-pracuj/business-variables/dist/beta';

const navigationUrls = {
  development: betaLinks,
  beta: betaLinks,
  production: productionLinks,
};

export { navigationUrls as default };